import * as React from "react";
import Style from "../../_data/models/Style";
import {Link} from "react-router-dom";
import {StylesRoutes} from "../../routes";
import {ResourceType} from "../../_helpers/data";
import LikeContainer from "../../_widgets/like/LikeContainer";
import User from "../../_data/models/User";

interface Props {
    item: Style;
}

const MyStylesGalleryImageComponent = (props: Props) => {

    let {item} = props;
    return (
        <div className="featured-image-block column">
            <Link to={StylesRoutes.showStyle(item.user.name, item.id)}>
                <img src={item.primaryPictureUrl} alt={item.description}/>
            </Link>
            <LikeContainer model={item} isGalleryView={true}/>
        </div>
    );

};

export default MyStylesGalleryImageComponent;


// WEBPACK FOOTER //
// ./app/client/style/components/MyStylesGalleryImageComponent.tsx